import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/production/setting'

/** 获取报工操作前置验证设置 */
export const reportValid = () => {
  return axios.get(`${rootApi}/reportValid`)
}
/** 获取工单展示设置 */
export const getWorkOrderDisplaySetting = () => {
  return axios.get(`${rootApi}/getWorkOrderDisplaySetting`)
}

/** 控制报工按钮的显示与隐藏 */
export const getReportButtonsSetting = () => {
  return axios.get(`${rootApi}/getReportButtonsSetting`)
}